export class RafEtiket{
    
    ID:number;
    StokKartiID:number;
    StokAdi:string;
    Barcode1:string;
    Barcode2:string;
    Price1:number;
    Price2:number;
    Price3:number;
    Price4:number;
    FiyatDegisimTarihi:string;
    UlkeAdi:string;
    BirimAdi:string;
    Miktar:number;
    
}


// WEBPACK FOOTER //
// ./src/models/RafEtiket.ts